module.exports = __webpack_public_path__ + "static/img/item2.c4c0fd51.png";